module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("授权管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("支付宝授权")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "info_wrapper"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("商户简称")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.name))]), _vm._v(" "), (_vm.haveAuthorize) ? _c('div', {
    staticClass: "authorizeSucText"
  }, [_vm._v("授权成功")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("支付宝账号")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_c('el-button', {
    class: _vm.haveAuthorize ? 'relieve-btn' : 'authorize-btn',
    attrs: {
      "size": "primary"
    },
    on: {
      "click": function($event) {
        _vm.haveAuthorize ? _vm.showrelieveView() : _vm.showQrcode()
      }
    }
  }, [_vm._v(_vm._s(_vm.haveAuthorize ? '解除授权' : '授权绑定'))])], 1)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showAuthorize,
      "custom-class": "mydialog",
      "top": "10%",
      "show-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showAuthorize = $event
      }
    }
  }, [_c('div', {
    staticClass: "text-tip"
  }, [_c('p', [_vm._v("请打开手机端"), _c('span', [_vm._v("支付宝扫一扫")])]), _vm._v(" "), _c('p', [_vm._v("扫描二维码完成授权操作")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "arrows-down"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail_footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    attrs: {
      "id": "qrcodeContainer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "success-btn",
    on: {
      "click": function($event) {
        return _vm.checkRequest()
      }
    }
  }, [_c('div', [_vm._v("支付宝提示已绑定成功，点这里")])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.showReviseConfirm,
      "top": "20%",
      "custom-class": "mydialog",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showReviseConfirm = $event
      }
    }
  }, [_c('span', {
    staticClass: "tip-text"
  }, [_vm._v("是否确认解除授权？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer dialog-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "dialog-btn",
    on: {
      "click": function($event) {
        _vm.showReviseConfirm = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "dialog-btn green-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.relieveBound
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("授权信息")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("常见问题")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "info_wrapper"
  }, [_c('p', {
    staticClass: "info_text_title"
  }, [_vm._v("如何查看支付宝账号是否有签约支付宝2.0？")]), _vm._v(" "), _c('div', {
    staticClass: "question"
  }, [_c('p', [_c('span', [_vm._v("pc端：")]), _vm._v("点击登陆支付宝，查看我的签约产品")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("手机号客户端：")]), _vm._v("打开手机支付宝客户端＞朋友＞生活号，搜索“蚂蚁金服商家平台”，点击服务指引＞签约当面付，查看是否已完成签约。")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7f54670a"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/kbauthorize/kbauthorize.vue
// module id = 839
// module chunks = 0